import moment from 'moment';
import coBrandedCards from '../../../../constants/user-profile';
import {
  bagNames,
  getAncillaryNameInsurance,
  getDtd,
  getFareType,
  passengerCount,
  sortAlphabetically,
} from '../../../../utilities/helpers';
import { cardTypes } from '../../../utils/metrics-utils';
import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';
import { CARRY_ON_LABELS } from '../ecommerce/constants';

export default ({
  ancillariesForPurchaseMetric,
  creditCard,
  isActiveFlowCorporate,
  modifiedPNRModel,
  paymentFormData,
  pnrInfo,
  purchaseOrder,
  userCorporate,
  userProfile,
}) => {
  const flightTypeMap = {
    ONEWAY: 'OW',
    ROUNDTRIP: 'RT',
  };
  const flightType = flightTypeMap[pnrInfo?.flightItineraryType] || 'MC';
  const market = pnrInfo?.globalMarketFlight;
  let tripType = 'MC';
  let zone = 'NA';
  if (market === 'DOMESTIC') {
    zone = 'DOM';
  } else if (market === 'INTERNATIONAL' || market === 'TRANSBORDER') {
    zone = 'INT';
  }

  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  const collection = pnrInfo?.legCollection || [];
  const departureAirport = pnrInfo?.legCollection?.[0]?.segmentsCollection?.[0]?.departureAirport;
  const arrivalAirport = pnrInfo?.legCollection?.[0]?.segmentsCollection?.[pnrInfo?.legCollection?.[0]?.segmentsCollection?.length - 1]?.arrivalAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';
  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}` || 'NA';
  }
  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];
  const travelerCount = passengerCount(travelerCollection);

  const segments = [];
  let stopsNumbers = 0;
  const legCollection = pnrInfo?.legCollection || [];

  legCollection.forEach((element) => {
    const data = element?.segmentsCollection || [];
    stopsNumbers = data?.length > 1 ? stopsNumbers + (data?.length - 1) : stopsNumbers;
    data.forEach((segmentsData) => {
      segments.push(segmentsData);
    });
  });

  const ancillaries = ancillariesForPurchaseMetric;
  const upgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type == 'UPG');
  const nonUpgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type != 'UPG');
  
  const seatAncillaries = modifiedPNRModel?.confirmationModel?.cartConfirmation?.travelerCollection?.map(({ segmentChoices }) => segmentChoices);
  const itemsArray = seatAncillaries?.map(obj => obj.items)?.reduce((acc, curr) => acc.concat(curr), []);
  const seatAncillariesArray = itemsArray?.map(({ segmentCode, redeemedCP, seat }) => ({ segmentCode: segmentCode, redeemedCP: redeemedCP, commercialName: 'seat', type: seat?.code, totalCPPoints: seat?.currency?.totalCPPoints, total: seat?.currency?.total }));
  const ancillariesArray = nonUpgFilterAncillariesArray?.map(({ ancillary, legCode, segmentCode }) => ({ redeemedCP: ancillary?.redeemedCP, segmentCode: segmentCode, commercialName: ancillary?.commercialName, type: ancillary?.type, totalCPPoints: ancillary?.currency?.totalCPPoints, total: ancillary?.currency?.total, legCode: legCode }));
  const upgAncillariesArray = (upgFilterAncillariesArray || []).map(( { ancillary }) => ({ redeemedCP: ancillary?.redeemedCP, segmentCode: ancillary?.segmentCode, commercialName: 'UPG', type: ancillary?.ancillaryOffer?.ancillary?.type, totalCPPoints: ancillary?.ancillaryOffer?.ancillary?.currency?.totalCPPoints, total: ancillary?.ancillaryOffer?.ancillary?.currency?.total }));
  const allAncillaries = [...ancillariesArray, ...seatAncillariesArray, ...upgAncillariesArray];

  const allPoints = allAncillaries?.every(({ redeemedCP }) => redeemedCP === true);

  let fopTpeItem = 'Cash';
  const dtd = getDtd(segments?.[0]?.departureDateTime);
  const items = [];  

  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  const inboundArrivalAirport = inboundSegments?.[inboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const inboundDepartureAirport = inboundSegments?.[0]?.departureAirport || 'NA';
  const outboundName = marketOd;
  const inboundName =  `${inboundDepartureAirport}${inboundArrivalAirport}`;
  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');
  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';

  const mcOutBoundDepartureDate = (legCollection || []).map((legData) => {
    const firstSegment = legData?.segmentsCollection[0] || [];
    const departureDate = firstSegment?.departureDateTime?.format('YYYYMMDD') || 'NA';
    return departureDate;
  }).join('-');

  const mcOutBoundArrivalDate = (legCollection || []).map((legData) => {
    const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
    const arrivalDate = lastSegment?.arrivalDateTime?.format('YYYYMMDD') || 'NA';
    return arrivalDate;
  }).join('-');

  let marketSegment = [];
  const marketTest = [];
  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const tmpMarketSegmet = [];
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      tmpMarketSegmet.push(`${segmentsData?.departureAirport}${segmentsData?.arrivalAirport}`);
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    marketTest.push(tmpMarketSegmet.join('/'));
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  marketSegment = marketTest.join('-');
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  let mcPrice = 0;
  (modifiedPNRModel?.products || []).forEach((product) => {
    const productId = product?.id;
    const baggageId = ['0IA', '0CD', '0CE', '0CF', '0CG', '0CH', '0CI', '0LX', '0JH', '0LL', '02T', 'XB5', 'XB6', 'XB7'];
    const baggage = baggageId?.includes(productId);
    const seatTypes = ['AMPlus Seat', 'Emergency Exit Seat', 'Preferred Seat'];
    const seat = seatTypes?.includes(product?.name);
    let itemAffiliation = 'AM';
    let itemCategory = 'Ancillary';
    let itemCategory2 = 'NA';
    let itemCategory3 = 'NA';
    let itemListName = 'NA';
    let price = 0;
    let quantity = 0;
    let aircraftType = 'NA';
    let aircraftSubfleet = 'NA';
    let mcFlightTime = 0;
    let cabinItem = 'NA';
    let classItem = 'NA';
    let marketSegmentsItem = 'NA';
    let inboundDepartureDateItem = 'NA';
    let outboundDepartureDateItem = 'NA';
    const leg = product?.category;
    let currentAncillary = (allAncillaries || []).find(product => product.type == productId);
    fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
    switch (productId) {
      case 'AMS':
      case 'SEP':
      case 'SDE':
      case 'SXC':
      case 'SXP':
      case 'SVI':
        itemCategory = 'Insurance';
        itemCategory2 = getAncillaryNameInsurance(productId);
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Insurance outbound' :
          'Insurance outbound and Insurance inbound';
        break;
      case 'AMK':
        itemCategory = 'Services';
        itemCategory2 = 'Concierge';
        itemCategory3 = 'NA';
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Services outbound' :
          'Services outbound and services inbound';
        break;
      case 'DPM':
      case 'DPI':
        itemCategory = 'Services';
        itemCategory2 = 'Discount Pass';
        itemCategory3 = pnrInfo?.globalMarketFlight === 'DOMESTIC' ? 'MEXICO' : 'INTERNATIONAL';
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Services outbound' :
          'Services outbound and services inbound';
        break;
      case '09T':
        itemCategory = 'Services';
        itemCategory2 = 'Fly Green';
        itemCategory3 = 'NA';
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '07X':
        itemCategory2 = CARRY_ON_LABELS.CARRY_ON;
        itemCategory3 = CARRY_ON_LABELS.CARRY_ON_PLUS_5KG;
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '0CZ':
        itemCategory2 = CARRY_ON_LABELS.CARRY_ON;
        itemCategory3 = CARRY_ON_LABELS.CARRY_ON_10KG;
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '029':
        itemCategory2 = 'CBX';
        itemCategory3 = 'NA';
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case 'UPG':
        itemCategory = 'Upgrade';
        itemCategory2 = segments?.[0]?.fareFamily;
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = travelerCount?.adults + travelerCount?.child + travelerCount?.adultMinors;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'upgrade outbound' :
          'Upgrade outbound upgrade inbound';
        break;
      default:
        if (seat) {
          itemCategory2 = 'Seat';
          itemCategory3 = product?.name + '|' + product?.id;
          itemAffiliation = 'AM';
          price = product?.price;
          quantity = product?.quantity;
          itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
            'Ancillaries outbound ancillaries inbound';
        }
        break;
    }

    if (baggage) {
      itemCategory2 = 'Luggage';
      const productname = product?.name;
      const split = productname?.split('/');
      const bagName = split?.[0];
      itemCategory3 = bagNames(bagName);
      itemAffiliation = 'AM';
      price = product?.price;
      quantity = product?.quantity;
      itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
        'Ancillaries outbound ancillaries inbound';
    }

    itemCategory2 = itemCategory2?.trim(); 
    itemCategory3 = itemCategory3?.trim(); 

    let pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
    if (currentAncillary?.redeemedCP) {
      price = 0;
    }

    let params = {};
    legCollection.forEach((legItem, legIndex) => {
      const legType = legItem?.itineraryPartType;
      const ancillaries = ['Concierge', 'Insurance', 'Discount Pass'];
      const flyGreenItem = ['Fly Green'];
      const isFlyGreen = flyGreenItem.includes(itemCategory2);
      const ancillaryIncluded = itemCategory === 'Insurance' ? ancillaries?.includes(itemCategory) : ancillaries?.includes(itemCategory2);
      const luggageItems = ['Luggage', 'hand luggage'];
      const upgradeItemName = ['Upgrade'];
      const cbxItem = ['CBX'];
      const isBaggage = luggageItems?.includes(itemCategory2);
      const isCBX = cbxItem.includes(itemCategory2);
      currentAncillary = isCBX ? (allAncillaries || []).find((produc) => produc?.legCode === legItem?.legCode) :
        isBaggage ? (allAncillaries || []).find((produc) => produc?.legCode === legItem?.legCode && productId === produc.type) : currentAncillary;
      const isSameLegCode = legItem?.legCode == currentAncillary?.legCode;
      const isUpgrade = upgradeItemName?.includes(itemCategory);
      let nameToCompare = legItem?.itineraryPartType === 'OUTBOUND' ? outboundName : inboundName;
      const firstSegments = legItem?.segmentsCollection?.[0];
      const lastSegments = legItem?.segmentsCollection?.[legItem?.segmentsCollection?.length - 1];
      const lastSegmentsAirport = lastSegments?.arrivalAirport || 'NA';
      const firstSegmentsAirport = firstSegments?.departureAirport || 'NA';
      nameToCompare = tripType === 'MC' ? `${firstSegmentsAirport}${lastSegmentsAirport}` : nameToCompare;
      if (isBaggage && isSameLegCode) {
        fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
        pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
        price = currentAncillary?.redeemedCP ? 0 : currentAncillary?.total;
      }
      
      if (isCBX && isSameLegCode) {      
        const index2 = items?.findIndex((item) => item?.item_name === nameToCompare);
        if (index2 !== -1) return;
        quantity = (allAncillaries || []).filter((produc) => produc?.legCode === legItem?.legCode).length;
        price = currentAncillary?.total;
      }

      if ((isBaggage || isCBX) && !isSameLegCode) {
        return;
      }

      if (ancillaryIncluded && (legItem?.itineraryPartType === 'OUTBOUND' || legIndex === 0)) {
        (legItem?.segmentsCollection || []).forEach((segment, index) => {
          if (index > 0) return;
          const departureDateTime = moment(segment?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const flightTime = moment?.utc(legItem?.totalFlightTimeInMinutes * 60000).format('HH:mm');
          const marketNdodItem = marketNdod;
          const regionCode = segment?.regionKeyFromLeg;
          const transactionDate = moment(pnrInfo?.creationDate);
          const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
          const apItem = apiDepartureDate.diff(transactionDate, 'days');
          const apItemRanges = [
            { min: 0, max: 2, range: '0 a 2' },
            { min: 3, max: 6, range: '3 a 6' },
            { min: 7, max: 13, range: '7 a 13' },
            { min: 14, max: 20, range: '14 a 20' },
            { min: 21, max: 27, range: '21 a 27' },
            { min: 28, max: 49, range: '28 a 49' },
            { min: 50, max: 89, range: '50 a 89' },
            { min: 90, max: 119, range: '90 a 119' },
            { min: 120, max: 149, range: '120 a 149' },
            { min: 150, max: Infinity, range: '150+' },
          ];
          
          const apItemRangeObj = apItemRanges.find(({ min, max }) => apItem >= min && apItem <= max);
          const apItemRange = apItemRangeObj ? apItemRangeObj.range : 'NA';

          const upSellAmount = 0;
          let msItem = 0;
          if (segments?.length > 1) {
            const firstSegment = moment(segments?.[0]?.departureDateTime);
            const lastSegment = moment(segments?.[segments?.length - 1]?.arrivalDateTime);
            msItem = lastSegment.diff(firstSegment, 'days');
          }
          const coupon = 'NA';
          const discount = 0;
          const itemBrand = itemCategory === 'Insurance' ? 'CHUBB' : 'AM';
          const bookingFeeAmrpoints = pnrInfo?.cart?.bookingFee || 0;
          const outboundDepartureDateItem = segment?.departureDateTime.format('YYYYMMDD');
          const inboundDepartureDateItem = (pnrInfo?.flightItineraryType === 'ROUNDTRIP') ? pnrInfo?.legCollection?.[pnrInfo?.legCollection?.length - 1]?.segmentsCollection?.[index]?.departureDateTime.format('YYYYMMDD') : 'NA';
          const airportTax = pnrInfo?.cart?.total?.taxDetails?.TUA || 0;
          const opCarrier = segment?.operatingCarrier;
          const brandedFare = getFareType(segment);

          if (pnrInfo?.isOnHold) {
            itemListName = tripType === 'RT' ? 'Flights outbound and inbound' : 'Flights outbound';
          }
          
          params = {
            'item_name': marketOd || 'NA',
            'coupon': coupon,
            'discount': discount,
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': itemCategory2,
            'item_category3': itemCategory3,
            'item_list_name': itemListName,
            'item_affiliation': itemAffiliation,
            'price': price,
            'quantity': quantity,
            'index': index,
            'booking_fee_amrpoints': bookingFeeAmrpoints,
            'market_ndod_item': marketNdodItem || 'NA',
            'market_od_item': marketOd || 'NA',
            'market_segment_item': marketSegment,
            'zone_item': zone || 'NA',
            'region_item': regionCode || 'NA',
            'flight_time_dep': departureDateTime,
            'flight_time': flightTime,
            'branded_fare': brandedFare === 'MAIN_LIGHT' ? 'LIGHT' : brandedFare,
            'upsell_amount': upSellAmount || 0,
            'outbound_departure_date_item': outboundDepartureDateItem || 'NA',
            'inbound_departure_date_item': inboundDepartureDateItem,
            'fop_type_item': fopTpeItem,
            'price_points': pricePoint,
            'airport_tax': airportTax,
            'aircraft_type': segment?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${segment?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'ms_item': msItem,
            'cabin_item': segment?.cabin || 'NA',
            'class_item': segment?.bookingClass || 'NA',
          };
          items.push(params);
        });
      } else if (!ancillaryIncluded) {
        const connectedFlights = legItem?.legType === 'CONNECTING' && baggage ? [legItem?.segmentsCollection?.[0]] : legItem?.segmentsCollection;
        (connectedFlights || []).forEach((flight, index) => {
          const departureDateTime = moment(flight?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const flightTime = moment?.utc(flight?.flightDurationInMinutes * 60000).format('HH:mm');
          let marketOdItem = flight?.departureAirport + flight?.arrivalAirport;
          let marketNdodItem = sortAlphabetically(flight?.arrivalAirport, flight?.departureAirport) || 'NA';

          const regionCode = flight?.regionKeyFromLeg;
          const transactionDate = moment(pnrInfo?.creationDate);
          const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
          const apItem = apiDepartureDate.diff(transactionDate, 'days');
          const apItemRanges = [
            { min: 0, max: 2, range: '0 a 2' },
            { min: 3, max: 6, range: '3 a 6' },
            { min: 7, max: 13, range: '7 a 13' },
            { min: 14, max: 20, range: '14 a 20' },
            { min: 21, max: 27, range: '21 a 27' },
            { min: 28, max: 49, range: '28 a 49' },
            { min: 50, max: 89, range: '50 a 89' },
            { min: 90, max: 119, range: '90 a 119' },
            { min: 120, max: 149, range: '120 a 149' },
            { min: 150, max: Infinity, range: '150+' },
          ];
          
          const apItemRangeObj = apItemRanges.find(({ min, max }) => apItem >= min && apItem <= max);
          const apItemRange = apItemRangeObj ? apItemRangeObj.range : 'NA';

          const upSellAmount = 0;
          let msItem = 0;
          if (segments?.length > 1) {
            const firstSegment = moment(segments?.[0]?.departureDateTime);
            const lastSegment = moment(segments?.[segments?.length - 1]?.arrivalDateTime);
            msItem = lastSegment.diff(firstSegment, 'days');
          }
          const coupon = 'NA';
          const discount = 0;
          const itemBrand = 'AM';
          const bookingFeeAmrpoints = pnrInfo?.cart?.bookingFee || 0;
          const airportTax = pnrInfo?.cart?.total?.taxDetails?.TUA || 0;
          const segment = flight?.departureAirport + '-' + flight?.arrivalAirport;
          const connectingFlights = legItem?.segmentsCollection;
          let segmentCheck = false;
          let itemName = marketOdItem;
          const seatCheck = seat ? false : legItem?.legType === 'CONNECTING';
          if (leg?.includes(segment)
             || leg?.includes(connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport  + '-' + connectingFlights?.[0]?.departureAirport)) {
            segmentCheck = true;
          }
          const opCarrier = flight?.operatingCarrier;
          let itemListName = legType === 'OUTBOUND' ? 'Ancillaries outbound' : 'Ancillaries inbound';
          itemListName = tripType == 'MC' ? 'Ancillaries outbound' : itemListName;
          let currentUpg = null;
          if (isUpgrade) {
            currentUpg = upgAncillariesArray?.find(upg => upg?.segmentCode == flight?.segmentCode);
            fopTpeItem = currentUpg?.redeemedCP ? 'Points' : 'Cash';
            pricePoint = currentUpg?.redeemedCP ? currentUpg?.totalCPPoints : 0;
            price = currentUpg?.redeemedCP ? 0 : currentUpg?.total;
            const index = items?.findIndex((item) => item?.item_category === 'Upgrade' && item?.item_name === marketOdItem && departureDateTime === item?.flight_time_dep);
            if (!currentUpg || index !== -1) return;
            itemListName = legType == 'OUTBOUND' ? 'Upgrade outbound' : 'Upgrade inbound';
            itemListName = tripType == 'MC' ? 'Upgrade outbound' : itemListName;
            segmentCheck = true;
          }

          if (itemCategory2 == 'Seat') {
            currentAncillary = (allAncillaries || []).find((product2) => product2?.segmentCode === flight?.segmentCode && product2?.type === product?.id);
            const isSameSegmentCode = flight?.segmentCode === currentAncillary?.segmentCode;
      
            if (isSameSegmentCode) {
              fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
              pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
              price = currentAncillary?.redeemedCP ? 0 : currentAncillary?.total;
            }
          }
          
          if (isFlyGreen) {
            const index2 = items?.findIndex((item) => item?.item_category2 === 'Fly Green' && item?.item_name === marketOdItem && departureDateTime === item?.flight_time_dep);
            currentAncillary = allAncillaries.find((item) => item?.segmentCode === flight?.segmentCode && productId === item.type && item?.legCode === legItem?.legCode);
            if (index2 !== -1 || !currentAncillary) return;
            quantity = (allAncillaries || []).filter((item) => (item?.segmentCode === flight?.segmentCode) && productId === item.type).length;
            price = currentAncillary?.total;
            segmentCheck = true;
          }

          if (isCBX) {
            if (index > 0) return;
            itemName = legItem?.itineraryPartType == 'OUTBOUND' ? outboundName : inboundName;
            itemName = tripType === 'MC' ? `${firstSegmentsAirport}${lastSegmentsAirport}` : itemName;
            itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' : itemListName;
            marketNdodItem = sortAlphabetically(firstSegmentsAirport, lastSegmentsAirport);
            marketOdItem = `${firstSegmentsAirport}${lastSegmentsAirport}`;
            cabinItem = (connectingFlights || []).map((segment) => {
              return `${segment?.cabin || 'NA'}`;
            }).join('/');
            classItem = (connectingFlights || []).map((segment) => {
              return `${segment?.bookingClass || 'NA'}`;
            }).join('/');
          }

          if (pnrInfo.inOnHold && legItem.itineraryPartType === 'OUTBOUND') {
            itemListName = 'Flights outbound';
            itemListName = tripType == 'MC' ? 'Flights outbound' : itemListName;
          } else if (pnrInfo.inOnHold && legItem.itineraryPartType === 'INBOUND') {
            itemListName = 'Flights inbound';
            itemListName = tripType == 'MC' ? 'Flights outbound' : itemListName;
          }

          if ((baggage || isCBX) && legItem?.legType === 'CONNECTING') {
            marketSegmentsItem = (connectingFlights || []).map((segment) => {
              return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
            }).join('/');
          }

          if (baggage && legItem?.legType === 'CONNECTING') {
            mcPrice = 0;
            marketOdItem = connectingFlights?.[0]?.departureAirport + connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport;
            marketNdodItem = sortAlphabetically(connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport, connectingFlights?.[0]?.departureAirport) || 'NA';
            (connectingFlights || []).forEach((segment) => {
              mcPrice +=  segment?.layoverToNextSegmentsInMinutes + segment?.flightDurationInMinutes;
            });
            mcFlightTime = moment?.utc(mcPrice * 60000).format('HH:mm');
            outboundDepartureDateItem = legItem?.itineraryPartType === 'OUTBOUND' || tripType === 'MC' ? connectingFlights?.[0]?.departureDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.departureDateTime?.format('YYYYMMDD') : 'NA';
            inboundDepartureDateItem = legItem?.itineraryPartType === 'INBOUND' && tripType === 'RT' ? connectingFlights?.[0]?.arrivalDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
            aircraftType = connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            aircraftSubfleet = connectingFlights?.[0]?.operatingCarrier + connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.operatingCarrier + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            cabinItem = connectingFlights?.[0]?.cabin + '/' + connectingFlights?.[connectingFlights?.length - 1]?.cabin;
            classItem = connectingFlights?.[0]?.bookingClass + '/' + connectingFlights?.[connectingFlights?.length - 1]?.bookingClass;
          }

          const brandedFare = getFareType(flight);
          const flightDuration = legItem.legType === 'CONNECTING' && baggage ? mcFlightTime : flightTime;
          const marketSegmntItem = legItem?.legType === 'CONNECTING' && (baggage || isCBX) ? marketSegmentsItem : marketOdItem || 'NA';
          const outbounDepartureItem = legItem?.legType === 'CONNECTING' && baggage ? outboundDepartureDateItem : outboundDepartureDate || 'NA';
          const inboundDepartureItem = legItem?.legType === 'CONNECTING' && baggage  ? inboundDepartureDateItem : inboundDepartureDate || 'NA';
          const airCraft = legItem?.legType === 'CONNECTING' && baggage ? aircraftType : flight?.aircraftType || 'NA';
          const CraftSubfleet =  legItem?.legType === 'CONNECTING' && baggage ? aircraftSubfleet : `${opCarrier}${flight?.aircraftType}` || 'NA';
          const cabinItems = legItem?.legType === 'CONNECTING' && (baggage || isCBX) ? cabinItem : flight?.cabin || 'NA';
          const classItems = legItem?.legType === 'CONNECTING' && (baggage || isCBX) ? classItem : flight?.bookingClass || 'NA';

          const titleName = baggage && legItem?.legType === 'CONNECTING' ? marketOdItem : itemName;
          if (segmentCheck || seatCheck) {
            params = {
              'item_name': titleName,
              'coupon': coupon,
              'discount': discount,
              'item_brand': itemBrand,
              'item_category': itemCategory,
              'item_category2': itemCategory2,
              'item_category3': itemCategory3,
              'item_list_name': itemListName,
              'item_affiliation': itemAffiliation,
              'price': price,
              'quantity': quantity,
              'index': index,
              'booking_fee_amrpoints': bookingFeeAmrpoints,
              'market_ndod_item': marketNdodItem || 'NA',
              'market_od_item': marketOdItem || 'NA',
              'market_segment_item': marketSegmntItem,
              'zone_item': zone || 'NA',
              'region_item': regionCode || 'NA',
              'flight_time_dep': departureDateTime,
              'flight_time': flightDuration,
              'branded_fare': brandedFare === 'MAIN_LIGHT' ? 'LIGHT' : brandedFare,
              'upsell_amount': upSellAmount || 0,
              'outbound_departure_date_item': outbounDepartureItem,
              'inbound_departure_date_item': inboundDepartureItem,
              'fop_type_item': fopTpeItem,
              'price_points': pricePoint,
              'airport_tax': airportTax,
              'aircraft_type': airCraft,
              'aircraft_subfleet': CraftSubfleet,
              'ap_item': apItemRange,
              'ms_item': msItem,
              'cabin_item': cabinItems,
              'class_item': classItems,
            };
            items.push(params);
          }
        });
      }
    });
  });

  const updatedItems = items.filter((obj, index, item) =>
    index === item.findIndex((value) => (
      value?.price === obj?.price && value?.item_name === obj?.item_name && value?.item_category3 === obj?.item_category3 && value?.flight_time
      === obj?.flight_time
    ))
  );

  const corpSpid = pnrInfo?.clid?.companyNumber;
  const ffNumber = userProfile?.ffNumber ? `${userProfile?.ffNumber}` : 'NA';
  let ffProgram = 'NA';
  travelerCollection.forEach(passenger => {
    if (passenger?.frequentFlyerNumber === ffNumber) {
      ffProgram = passenger?.frequentFlyerProgram;
    }
  });

  let corpDiscount = '';
  const companiesData = pnrInfo?.userProfile?.corporateFlow?.data?.companies || [];
  companiesData.forEach((companiesData, index) => {
    corpDiscount += companiesData?.discountCode;
    if (index < companiesData?.length - 1) {
      corpDiscount += ',';
    }
  });
  const purchaseOrderCcNumber = purchaseOrder?.paymentInfo?.[0]?.ccNumber;
  const personalCreditCardsUser = pnrInfo?.userProfile?.personalCreditCards?._collection || [];
  let isCobrandCard = null;
  let shareBrand = null;
  let coBrandCardNames = null;

  personalCreditCardsUser.forEach((element) => {
    if (purchaseOrderCcNumber === element?.ccNumber) {
      isCobrandCard = element?.isCobranCard;
      if (isCobrandCard) {
        coBrandCardNames = element?.codeCobranCard;
      }
    }
  });

  if (coBrandCardNames) {
    shareBrand = coBrandedCards?.COBRANDED_CARDS_NAMES?.[coBrandCardNames] || 'NA';
  }
  const transactionId = pnrInfo?.confirmationModel?.transactionId || 'NA';
  const value = pnrInfo?.confirmationModel?.cartConfirmation?.total?.total || 0;
  const tax = pnrInfo?.confirmationModel?.cartConfirmation?.total?.totalTax || 0;
  const currency = pnrInfo?.confirmationModel?.cartConfirmation?.total?.currencyCode || 'NA';
  const coupon = pnrInfo?.cart?.travelerCollection?.[0]?.couponCode || 'NA';
  const installments = pnrInfo?.confirmationModel?.paymentSummary?.[0]?.installments?.numberOfMonths || 0;
  const airportTax = pnrInfo?.cart?.total?.taxDetails?.TUA || 0;
  const funnelName = 'MYB';
  const subFunnelName = 'Payment';
 
  let cardType = paymentFormData?.values ? cardTypes[paymentFormData?.values?.cardType] : cardTypes[paymentFormData?.cardType];
  cardType = cardType ? cardType : 'NA';
  let bankId = paymentFormData?.values ? paymentFormData?.values?.cardCode : paymentFormData?.cardCode;
  const paymentValues = paymentFormData?.values;
  if (cardType === 'NA') {
    cardType = creditCard?.cardType ? creditCard?.cardType : 'NA';
  }
  if (!bankId) {
    bankId = creditCard?.cardCode; 
  }
  let paymentType = paymentValues?.cardCode || paymentFormData?.cardCode || creditCard?.cardCode ? 'CREDIT CARD' : 'UATP';
  if (paymentType === 'UATP') {
    cardType = 'UATP';
    bankId = 'TP';
  }

  const region = pnrInfo?.legCollection?.[0]?.regionKey || 'NA';
  const valuePoints = modifiedPNRModel?.confirmationModel?.cartConfirmation?.total?.totalCPPoints || 0;
  const corpProgram = isActiveFlowCorporate ? 'AM Rewards Business' : 'NA';
  let corpId = 'NA';
  const companySelected = userCorporate?.companySelected;
  (userCorporate?.companies?.companies || []).forEach(company => {
    corpId = company?.companyName === companySelected ? company?.companyLoyaltyNumber : corpId;
  });

  const uniqueTypeofPayment =
    pnrInfo?.confirmationModel?.hasTicketedAncillary() || pnrInfo?.confirmationModel?.hasTicketedSeat() ? 'Cash' : 'Points';
  const fopType =
    (pnrInfo?.confirmationModel?.hasTicketedAncillary() || pnrInfo?.confirmationModel?.hasTicketedSeat())
      && (pnrInfo?.confirmationModel?.hasTicketedAncillaryPP() || pnrInfo?.confirmationModel?.hasTicketedSeatPP()) ? 'Cash+points' : uniqueTypeofPayment;

  paymentType = fopType === 'Points' ? 'NA' : paymentType;
  bankId = fopType === 'Points' ? 'NA' : bankId;
  cardType = fopType === 'Points' ? 'NA' : cardType;
  const result = {
    event: 'purchase',
    ecommerce: {
      'transaction_id': transactionId,
      'value': value,
      'tax': tax,
      'currency': currency,
      'coupon': coupon,
      'installments': installments,
      'payment_type': allPoints ? 'NA' : paymentType,
      'card_type': allPoints ? 'NA' : cardType,
      'share_brand': shareBrand || 'NA',
      'bank_id': allPoints ? 'NA' : bankId || 'NA',
      'pnr': pnrInfo?.pnrCode || 'NA',
      'airport_tax': airportTax,
      'funnel_name': funnelName,
      'sub_funnel_name': subFunnelName,
      'trip_type': flightType || 'NA',
      'fop_type': fopType || 'NA',
      'outbound_departure_date': tripType === 'MC' ? mcOutBoundDepartureDate : outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': tripType === 'MC' ? mcOutBoundArrivalDate : outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone || 'NA',
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegment || 'NA',
      'region': region,
      'value_points': valuePoints,
      'ffn_program': ffProgram || 'NA',
      'ffn_id': ffNumber,
      'corp_program': corpProgram,
      'corp_id': corpId,
      'corp_spid': corpSpid || 'NA',
      'corp_discount': corpDiscount || 'NA',
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'infants': travelerCount?.infants,
      'adult_minor': travelerCount?.adultMinors,
      'stops_number': stopsNumbers,
      'dtd': dtd || 'NA',
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': (collection?.[0]?.legType === 'CONNECTING' || collection?.[collection?.length - 1]?.legType === 'CONNECTING') ? updatedItems : items,
    },
  };

  
  // Customer.io Integration for Purchase Events
  // Send events for any purchase that contains ancillary items
  if (result?.ecommerce?.items && result.ecommerce.items.length > 0) {
    // Determine ancillary type from items or default to upgrades
    const firstItem = result?.ecommerce?.items?.[0];
    let ancillaryType = 'upgrades'; // default
    
    if (firstItem?.item_category2) {
      const category = firstItem.item_category2.toLowerCase();
      if (category.includes('seat')) {
        ancillaryType = 'seatselection';
      } else if (category.includes('bag') || category.includes('luggage')) {
        ancillaryType = 'ckdbags';
      } else if (category.includes('insurance')) {
        ancillaryType = 'travelinsurance';
      }
    }
    sendAncillaryEventToCustomerIO(ancillaryType, result, pnrInfo);
  }

  return result;
};
